import { Dispatch, SetStateAction, useMemo } from "react";

type StateType<T> = [T, Dispatch<SetStateAction<T>> | undefined];

export default <V, T>(
  key: keyof T,
  context: T,
  options?: {
    defaultValue?: V;
  },
): StateType<V> | [undefined, undefined] => {
  return useMemo(() => {
    const state = context[key];
    if (!state) {
      if (options?.defaultValue) return [options.defaultValue, undefined];
      return [undefined, undefined];
    }

    return state as StateType<V>;
  }, [key, context]);
};
